import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    editPeerConfiguration: [],
    loading: false,
    error: null,
}

const editPeerConfigurationSlice = createSlice({
    name: "editPeerConfiguration",
    initialState,
    reducers: {
        fetcheditPeerConfigurationSuccess: (state, action) => {
            state.loading = false,
            state.editPeerConfiguration = action.payload;
        },
        fetcheditPeerConfigurationFailure: (state, action) => {
            state.loading = false,
            state.error = action.payload;
        },
    },
})

export const {
    fetcheditPeerConfigurationSuccess,
    fetcheditPeerConfigurationFailure,
} = editPeerConfigurationSlice.actions;

export default editPeerConfigurationSlice.reducer;